<template>
  <div class="logout-container">
    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';

const router = useRouter();
const userStore = useUserStore();

const error = ref('');
const isLoading = ref(false);

const handleLogout = async () => {
  error.value = '';
  isLoading.value = true;
  try {
    await userStore.logout();
    await router.push('/login');
  } catch (err) {
    error.value = 'An error occurred during logout. Please try again.';
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  handleLogout();
});
</script>

<style scoped>
.logout-container {
  max-width: 300px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}
button {
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  cursor: pointer;
  margin-top: 15px;
}
button:disabled {
  background-color: #cccccc;
}
.error-message {
  color: red;
  margin-top: 15px;
}
</style>
